import { Check } from "lucide-react";
import { useParams } from "react-router-dom";
import Button from "../components/Button";
import CTA from "../components/public/CTA";
import PageHero from "../components/PageHero";
import RelatedServicesCarousel from "../components/public/RelatedServicesCarousel";
import SectionHeading from "../components/SectionHeading";
import { getService } from "../data/services";
import NotFound from "./NotFound";
import { CUSTOMER_PORTAL_URL } from "../lib/portal";
import { usePublicAuth } from "../context/PublicAuthContext";

export function ServiceDetail() {
  const { user, loading: authLoading } = usePublicAuth();
  const { slug } = useParams();
  const service = getService(slug);
  if (!service) return <NotFound />;
  const Icon = service.icon;
  return (
    <>
      <PageHero
        eyebrow={service.shortTitle}
        title={service.title}
        copy={service.description}
      >
        {!authLoading && <div className="mt-8">
          <Button href={`${CUSTOMER_PORTAL_URL}/${user ? "dashboard" : "signup"}`}>{user ? "Open dashboard" : "Get started"}</Button>
        </div>}
      </PageHero>
      <section id="content" className="section-space bg-white">
        <div className="container grid gap-14 lg:grid-cols-[.8fr_1.2fr]">
          <div>
            <div className="grid h-20 w-20 place-items-center rounded-3xl bg-mist text-ocean">
              <Icon size={34} />
            </div>
            <p className="mt-8 text-sm font-bold uppercase tracking-[.18em] text-ocean">
              What we handle
            </p>
            <ul className="mt-5 space-y-4">
              {service.bullets.map((bullet) => (
                <li
                  key={bullet}
                  className="flex gap-3 text-sm leading-7 text-slate"
                >
                  <Check size={18} className="mt-1 shrink-0 text-bridge" />
                  {bullet}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <SectionHeading
              eyebrow="A clear path forward"
              title="From first conversation to completed service."
              copy="The exact milestones depend on your brief. The shape of the experience stays simple and visible."
            />
            <div className="mt-10 space-y-4">
              {service.workflow.map((step, index) => {
                const title = typeof step === "string" ? step : step.title;
                const description =
                  typeof step === "string"
                    ? "Your project manager keeps this step visible in the customer portal."
                    : step.description;
                return (
                  <div
                    key={title}
                    className="flex gap-5 rounded-2xl border border-ink/10 p-5"
                  >
                    <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-ocean text-xs font-bold text-white">
                      {index + 1}
                    </span>
                    <div>
                      <h3 className="font-display font-bold text-ink">{title}</h3>
                      <p className="mt-1 text-sm leading-6 text-slate">{description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>
      <RelatedServicesCarousel currentSlug={service.slug} />
      <CTA />
    </>
  );
}
